import { gql } from '@apollo/client';

export const LeadFragment = gql`
  fragment LeadFragment on Lead {
    address {
      street
    }
    email
    fullName
    flip {
      participants {
        name
        roles
      }
    }
    initialCustomer {
      email
      fullName
    }
    offer {
      acceptedAt
      acceptanceExpiresAt
      assessmentScheduled
      assessmentSchedulingExpiresAt
      closeEscrowDate
      coBrokePercentage
      expiredAt
      feeCostCents
      hasActiveRepairAddendums
      id
      netProceedsCents
      offerDeclined
      purchaseAgreementExpiresAt
      recordedPriceCents
      scheduledEaTime
      scheduledOrvaTime
      sellerVisibleValuationRangeEndCents
      sellerVisibleValuationRangeStartCents
      state
      token
      totalContractDiscountPercentage
      underwritingRepairCreditCents
      withdrawnAt
      underwritingUea {
        state
        estimatedNetProceedsCents
        underwritingRecordedPriceCents
      }
    }
    offerRequestDenied
    phoneNumber
    qualifiedAt
    state
  }
`;
